import styled from "styled-components";
import futVector from "@/assets/football-vector.png";
import { styled as muiStyled } from "@mui/material";
import { FutButton } from "@/components/FutButton";

export const BackgroundVector = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 100%;
  background: url(${futVector});
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: contain;
  z-index: -1;
`;

export const Navigation = styled.nav`
  position: sticky;
  top: 0;
  width: 100%;
  height: 60px;
  background-color: red;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 35px;
  background-color: #242C35;
  z-index: 2;
  img {
    max-width: 100%;
    width: 150px;
  }

  @media only screen and (max-width: 1200px) {
    padding: 0 10px;
  }
`;

export const LoginButton = muiStyled(FutButton)`
  padding: 5px 25px;
`;

export const MethodsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
`;

export const MethodsContainer = styled.div`
  background-color: ${(props) => props.theme.backgroundColor};
  width: 450px;
  max-width: 450px;
  padding: 32px;
  margin: 0 10px;
  border-radius: 5px;
`;

export const RadioContainer = styled.label`
  display: flex;
`;

export const RadioNameContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const PixQrContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

export const CopyPixContainer = styled.div`
  display: flex;
  gap: 10px;
`;

export const PixStepsContainer = styled.div`
  margin-top: 30px;
  div {
    display: flex;
    align-items: center;
    gap: 10px;
    position: relative;
    span {
      position: absolute;
      left: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      border-radius: 50px;
      background-color: ${(props) => props.theme.primary};
    }
    p {
      margin-left: 40px;
    }
  }
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;